import Marquee from "react-fast-marquee";
import { partnersIcons } from "views/landing/constants";

const LoopLine = () => {
  return (
    <div className="overflow-hidden max-w-[110vw] text-white">
      <Marquee
        className="w-full overflow-hidden"
        speed={50}
        gradient={false}
        play={true}
      >
        {partnersIcons.map(({ id, icon: Icon }) => (
          <div key={id + Math.random()} className=" mr-20">
            {Icon}
          </div>
        ))}
      </Marquee>
    </div>
  );
};

export default LoopLine;
